module.exports = __webpack_public_path__ + "media/images/icon_blank_gray-ad48b5bf324c70b0cbade7b9b35eb73f.png";